<template>
    <div>
            <b-modal no-fade size="l" id="modal-contacterror" ok-only title="Error" ok-title="OK">
                {{errMessage}}   
                </b-modal>
                <b-modal no-fade size="l" id="modal-messagesent" ok-only title="Message Sent" ok-title="OK">
                Thank you for contacting us. We will get back to you soon.  
                </b-modal>

        <b-container fluid>
            <b-row>
                <b-col style='margin-top:20px'><h4>Contact Us</h4></b-col>
                <b-col></b-col>
                <b-col></b-col>
            </b-row>
            <b-row style='margin-top:20px'>
                <b-col cols='10'>
                    <b-card
                        bg-variant="light" 
                        border-variant="secondary"
                        class="mb-2"
                        title='Contact kegseeker.com'
                        >
                            <!-- If no user, ask for company name -->
                            <b-input-group v-if="!currentUser" prepend="Company" 
                                class="mt-3"
                                >
                                <b-form-input v-model="generalCompany"  ></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>
                            
                            <!-- If no user, ask for email address -->
                            <b-input-group  v-if="!currentUser" prepend="Email" class="mt-3">
                                <b-form-input v-model="generalEmail"></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>

                            <b-input-group  v-if="currentUser" prepend="Subject" class="mt-3">
                                <b-form-input v-model="subject"></b-form-input>
                                <b-input-group-append>
                                </b-input-group-append>
                            </b-input-group>

                            <b-form-group  style='margin-top:20px'
                                class="mb-0"
                                label-for="textarea-formatter"
                                description="Your Message"
                                >
                                <b-form-textarea
                                    id="textarea-formatter"
                                    v-model="generalMessage"
                                    placeholder="Your message"
                                ></b-form-textarea>
                            </b-form-group>
                            <br>
                            <b-button  variant="info" @click="sendGeneralInquiry" class="button">Send</b-button>
                    </b-card>
                </b-col>

            </b-row>
        </b-container>
        <footer><pagefooter/></footer>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import {sendemailinfo} from './Myfunctions'
import {sendemailsupport} from './Myfunctions'
import Pagefooter from './Pagefooter'
const fb = require('../firebaseConfig.js')

    export default {
        components: {
            Pagefooter,
        },

        computed:{
            ...mapState(['userProfile', 'currentUser']),
                },
        data() {
            return {
                errMessage:'',
                generalCompany:'',
                generalEmail:'',
                generalMessage:'',
                subject:'',
                }
            },

        methods: {
            sendGeneralInquiry() {
                
                var isError = false
                if (this.generalMessage.length < 10 ) {
                    isError = true
                    this.errMessage = "Please enter at least ten characters in the message"
                }

                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.generalEmail)){

                }
                else {
                        if(!this.currentUser){
                            isError = true
                            this.errMessage = "Please check the email address"
                        }
                    }

                if (!this.currentUser&&(this.generalCompany.length < 3 )) {
                    isError = true
                    this.errMessage = "Please enter at least three characters for the company name"
                }

                if (this.currentUser&&(this.subject.length < 3 )) {
                    isError = true
                    this.errMessage = "Please enter at least 3 characters for subject"
                }

                if(isError){
                    this.$bvModal.show("modal-contacterror")
                    return
                }
                
                var mailData ={}
                //Logged in user
                if (this.currentUser){
                    mailData   = {
                        to:'mahim@kegseeker.com',
                        replyTo:this.currentUser.email,
                        from: this.userProfile.company +" <" + this.currentUser.email+">",
                        message:{
                            subject:this.subject,
                            html:this.generalMessage,
                        }
                    }
                    fb.emailToEmailCollection.add(mailData)
                }
                
                //Someone else
                else{
                    mailData   = {
                        to:'info@kegseeker.com',
                        replyTo:this.generalEmail,
                        from: this.generalEmail,
                        message:{
                            subject:'Keg Seeker Inquiry',
                            html:this.generalMessage,
                        }
                    }
                    fb.emailToEmailInfoCollection.add(mailData)
                    //sendemailinfo(this.generalEmail, this.generalCompany, this.generalMessage)
                }
                //Add to FB email collection
                
                    

                this.generalCompany = ''
                this.generalEmail=''
                this.generalMessage=''
                this.subject = ''
                this.$bvModal.show("modal-messagesent")
                },
                
            }
        
    }
</script>